interface ListingImportApiResponse {
  importId: string;
  status: string;
}

export async function postListingImportJson(
  url: string,
  body: Record<string, string>,
  fallbackMessage: string
): Promise<ListingImportApiResponse> {
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  }).catch(() => {
    throw new Error('Network error - check your connection and try again.');
  });

  if (!response.ok) {
    const parsed: unknown = await response.json().catch(() => null);
    const fromBody =
      typeof parsed === 'object' &&
      parsed !== null &&
      'error' in parsed &&
      typeof parsed.error === 'string'
        ? parsed.error
        : null;
    throw new Error(fromBody ?? `${fallbackMessage} (${response.status})`);
  }

  const data: unknown = await response.json();
  if (
    typeof data !== 'object' ||
    data === null ||
    !('importId' in data) ||
    typeof data.importId !== 'string' ||
    !('status' in data) ||
    typeof data.status !== 'string'
  ) {
    throw new Error(`${fallbackMessage} (invalid response)`);
  }
  return { importId: data.importId, status: data.status };
}
